// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { customCreateAccountStyles } from "@steiner/App/Widgets/CreateAccount/CustomCreateAccount";
import { color, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

customCreateAccountStyles.container = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        gap: 16px;
        flex-wrap: wrap;
        width: 100%;
    `,
};

customCreateAccountStyles.leftSide = {
    css: css`
        flex: 1;
        max-width: 680px;
        min-width: 400px;
        ${xScreen("lte", "md")} {
            min-width: 100%;
        }
    `,
};

customCreateAccountStyles.rightSide = {
    css: css`
        max-width: 400px;
    `,
};

customCreateAccountStyles.contactInformationTypography = {
    color: "text.accent",
    size: 20,
    weight: 300,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 12px;
    `,
};
